import React from "react";

const NotCompatibleWithMobile = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12 align-self-center text-center">
            <div className="d-flex justify-content-center align-items-center">
              <h2 style={{ color: "#ff9b44" }}>Oops, Mobile not supported.</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 align-self-center text-center">
            <div className="d-flex justify-content-center align-items-center">
              <p style={{ color: "#ff9b44" }}>
                Sorry, this website is only compatible with desktop devices.
                Please try accessing it from a computer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotCompatibleWithMobile;
